import { AutogenModelOrderCustomer, AutogenRowOrderCustomer } from "./autogen/AutogenModelOrderCustomer";

export class ModelOrderCustomer extends AutogenModelOrderCustomer<RowOrderCustomer> {
	constructor() {
		super(RowOrderCustomer);
	}
}

export class RowOrderCustomer extends AutogenRowOrderCustomer {
}